import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useState } from 'react';

// Components
import Tab from './Tab';
import TabGroup from './TabGroup';
import { useAccessibleInteractivity } from '../../../hooks';

// Styled Components
const TabbedContentContainer = styled.div`
  overflow: hidden;
`;

const ContentContainer = styled.div``;

const Content = styled.div`
  display: ${props => (props.active ? 'block' : 'none')};
`;

// Tabbed Component
const TabbedContent = ({ tabs, active, defaultTab, tabsAlign, tabSize, tabGraphic }) => {
  const [isActive, setIsActive] = useState(defaultTab);

  const onClickHandler = e => {
    setIsActive(e);
  };

  return (
    <TabbedContentContainer>
      <TabGroup tabsAlign={tabsAlign} tabSize={tabSize}>
        {tabs &&
          tabs.map((tab, index) => (
            <Tab
              key={index}
              tabSize={tabSize}
              url={tab.url}
              active={isActive == index}
              onClick={() => onClickHandler(index)}
              label={tab.label}
              icon={tab.icon}
              iconImage={tab.iconImage}
              tabGraphic={tabGraphic}
            />
          ))}
      </TabGroup>

      <ContentContainer>
        {tabs && tabs.map((tab, index) => <Content active={isActive == index}>{tab.content}</Content>)}
      </ContentContainer>
    </TabbedContentContainer>
  );
};

export default TabbedContent;

TabbedContent.propTypes = {
  /** You can align your tabs left, center or right on the page. Default is center. */
  tabsAlign: PropTypes.string,
  /** You can set the size of the tabs as small or large. Default is small. */
  tabSize: PropTypes.string,
};
